import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, Draggable);

document.addEventListener('DOMContentLoaded', () => {

    // Background parallax layers — desktop only
    const mm = gsap.matchMedia();
    mm.add('(min-width: 768px)', () => {

        const bgConfigs = [
            {
                cls: '.bg-pattern.bg-1',
                layers: [
                    { selector: '#bgl-1', speed: 0.15 },
                    { selector: '#bgl-2', speed: 0.5  },
                    { selector: '#bgl-3', speed: 0.1 },
                    { selector: '#bgl-4', speed: 0.7  },
                    { selector: '#bgl-5', speed: 0.9  },
                ],
            },
            {
                cls: '.bg-pattern.bg-2',
                layers: [
                    { selector: '#bgl-1', speed: 0.2  },
                    { selector: '#bgl-2', speed: 0.45 },
                    { selector: '#bgl-3', speed: 0.7  },
                    { selector: '#bgl-4', speed: 0.7  },
                ],
            },
            {
                cls: '.bg-pattern.bg-3',
                layers: [
                    { selector: '#bgl-1', speed: 0.1  },
                    { selector: '#bgl-2', speed: 0.3 },
                    { selector: '#bgl-3', speed: 0.35  },
                    { selector: '#bgl-4', speed: 0.8  },
                    { selector: '#bgl-5', speed: 0.95 },
                ],
            },
            {
                cls: '.bg-pattern.bg-4',
                layers: [
                    { selector: '#bgl-1', speed: 0.25 },
                    { selector: '#bgl-2', speed: 0.5  },
                    { selector: '#bgl-3', speed: 0.15 },
                ],
            },
            {
                cls: '.bg-pattern.bg-5',
                layers: [
                    { selector: '#bgl-1', speed: 0.15 },
                    { selector: '#bgl-2', speed: 0.25  },
                ],
            },
        ];

        bgConfigs.forEach(({ cls, layers }) => {
            document.querySelectorAll(cls).forEach((pattern) => {
                layers.forEach(({ selector, speed }) => {
                    const el = pattern.querySelector(selector);
                    if (!el) return;

                    gsap.to(el, {
                        yPercent: -80 * speed,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: pattern,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: true,
                        },
                    });
                });
            });
        });

    });



    // Button flair effect
    document.querySelectorAll('.btn, .wp-block-button__link').forEach((btn) => {
        const flair = btn.querySelector('.btn__flair');
        if (!flair) return;

        gsap.set(flair, { scale: 0 });
        const xSet = gsap.quickSetter(flair, 'xPercent');
        const ySet = gsap.quickSetter(flair, 'yPercent');

        const getXY = (e) => {
            const { left, top, width, height } = btn.getBoundingClientRect();
            const xTransformer = gsap.utils.pipe(
                gsap.utils.mapRange(0, width, 0, 100),
                gsap.utils.clamp(0, 100)
            );
            const yTransformer = gsap.utils.pipe(
                gsap.utils.mapRange(0, height, 0, 100),
                gsap.utils.clamp(0, 100)
            );
            return {
                x: xTransformer(e.clientX - left),
                y: yTransformer(e.clientY - top),
            };
        };

        btn.addEventListener('mouseenter', (e) => {
            const { x, y } = getXY(e);
            xSet(x);
            ySet(y);
            gsap.to(flair, { scale: 1, duration: 0.4, ease: 'power2.out' });
        });

        btn.addEventListener('mouseleave', (e) => {
            const { x, y } = getXY(e);

            // Find the closest edge and push the flair out through it,
            // so overflow:hidden clips it before scale:0 is visible
            const fromLeft   = x;
            const fromRight  = 100 - x;
            const fromTop    = y;
            const fromBottom = 100 - y;
            const min = Math.min(fromLeft, fromRight, fromTop, fromBottom);

            let exitX = x;
            let exitY = y;
            if      (min === fromLeft)   exitX = -60;
            else if (min === fromRight)  exitX = 160;
            else if (min === fromTop)    exitY = -60;
            else                         exitY = 160;

            gsap.killTweensOf(flair);
            gsap.to(flair, {
                xPercent: exitX,
                yPercent: exitY,
                scale: 0,
                duration: 0.35,
                ease: 'power2.in',
            });
        });

        btn.addEventListener('mousemove', (e) => {
            const { x, y } = getXY(e);
            gsap.to(flair, { xPercent: x, yPercent: y, duration: 0.4, ease: 'power2' });
        });
    });

    // Fade up elements animation
    const fadeUpElements = document.querySelectorAll('.anmi-fadeup');
    fadeUpElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

    // Fade up elements animation
    const autofadeUpElements = document.querySelectorAll('.auto-fadeup');
    autofadeUpElements.forEach((element, index) => {
        gsap.from(element, {
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

});

export default function initInitGsap() {
    gsap.registerPlugin(ScrollTrigger, Draggable);
}

